import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, Observable } from 'rxjs';
import { mergeMap, takeUntil } from 'rxjs/operators';
import { AuthenticationService } from '../authentication/authentication.service';

export const jwtInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthenticationService);

  let modifiedRequest = req;

  if (req.url.includes('id_token_hint')) {
    const [baseUrl, query] = req.url.split('?');
    const newUrl = query
      ?.split('&')
      .filter((p): boolean => !p.includes('id_token_hint'))
      .join('&');
    modifiedRequest = req.clone({ url: `${baseUrl}?${newUrl}` });
  }

  if (authService.ignoreUrlsForToken(req.url)) {
    return from(authService.getIdToken()).pipe(
      mergeMap((token): Observable<HttpEvent<unknown>> => {
        let withAuth = modifiedRequest;
        if (token) {
          withAuth = withAuth.clone({
            headers: withAuth.headers.append('Authorization', `Bearer ${token}`),
          });
        }

        return next(withAuth).pipe(takeUntil(authService.getCancellationTokenObservable()));
      }),
    );
  }

  return next(req);
};
